import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export interface SelectProps {
    margin?: string;
}

export const lynxSelectStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: ({ margin }: SelectProps) => margin,

            minWidth: 200,
            "& .MuiSelect-select:focus": {
                backgroundColor: `inherit`,
            },

            "& .MuiInputBase-root": {
                border: `1px solid ${theme.colors.neutrals.neutral200}`,
                padding: 0,
            },
            "& .MuiSelect-root": {
                padding: "5px",
            },
            "& .MuiSelect-icon": {
                width: "12px",
                height: "12px",
                marginTop: "6px",
                marginRight: "10px",
            },
            "& .MuiPopover-paper": {
                maxHeight: "100px",
            },
        },
        menuItem: {
            "&:hover": {
                backgroundColor: `${theme.colors.primary.blue75}`,
            },
        },
        selected: {
            "&.Mui-selected": {
                backgroundColor: `${theme.colors.primary.blue500}`,
                color: "white",
            },
            "&.Mui-selected:hover": {
                backgroundColor: `${theme.colors.primary.blue500}`,
            },
        },

        label: {
            lineHeight: "120%",
            marginBottom: "5px",
        },
    })
);
